import { cadenceBlockingStateValues } from '@poseidon/types/types/cadenceState.type';

/**
 * States in which a cadence is still in-progress ("active"), so it belongs in the
 * header campaign switcher. Filtering by STATE (not the `isActive` flag) is
 * deliberate — per POS-2216 terminal cadences can be left `is_active = true`
 * (the reply write-path sets `state = 'responded'` without clearing the flag).
 */
const BLOCKING_STATES = new Set<string>(cadenceBlockingStateValues);

/**
 * The one state where `is_active = false` CONTRADICTS the state rather than
 * explaining it.
 *
 * Pausing legitimately sets `is_active = false` alongside `state = 'paused'`
 * (pg.cadence.service.ts:240/280), and paused campaigns DO belong in the
 * switcher — CampaignSwitcherPure renders a dedicated pause icon for them. So
 * the flag may only veto `'active'`, never the other blocking states.
 */
const DEACTIVATABLE_STATE = 'active';

/**
 * A cadence is in-progress when its state is blocking, EXCEPT for the
 * self-contradictory `state = 'active'` + `is_active = false` pair (POS-2483),
 * which means the campaign was deactivated and replaced. 98 such legacy rows
 * exist in prod; without this veto they render as a second campaign pill on the
 * lead, showing the old campaign's name beside the new campaign's steps.
 *
 * Extracted from ContactDetailPageNextJs so the predicate is unit-testable
 * without pulling in that component's `next/router` + tRPC dependency tree.
 */
export const isCadenceInProgress = (c: { state: string; isActive?: boolean }) =>
  BLOCKING_STATES.has(c.state) && !(c.state === DEACTIVATABLE_STATE && c.isActive === false);
